import React from 'react';
import { oneOf } from 'prop-types';
import {
    useQuery,
    useCategory,
    useInCategorySearchPreviews,
    usePlatform,
} from 'hooks';
import { InCategorySearchSlider, InCategorySearchSelected } from './components';
import './InCategorySearchFilter.scss';

const InCategorySearchFilter = ({ listingType }) => {
    const category = useCategory();
    const [listData] = useInCategorySearchPreviews();
    const [query] = useQuery();
    const platform = usePlatform();

    const shouldDisplayCategoryPreviews =
        listingType === 'search' && listData.categoryPreviews?.length > 0;

    const shouldDisplaySelectedCategory =
        listingType === 'category' && query !== undefined;

    return (
        <div className="intra-category">
            {shouldDisplayCategoryPreviews && (
                <InCategorySearchSlider values={listData.categoryPreviews} />
            )}
            {shouldDisplaySelectedCategory && (
                <InCategorySearchSelected
                    category={category}
                    query={query}
                    platform={platform}
                />
            )}
        </div>
    );
};
InCategorySearchFilter.propTypes = {
    listingType: oneOf(['search', 'category']).isRequired,
};

InCategorySearchFilter.displayName = 'InCategorySearchFilter';

export default InCategorySearchFilter;
